import _ from "lodash";
import { periods, bases, variances, comparisons } from "./reportConstants";

const getAccountKey = (item) =>
  [item.AccountCode !== "0" ? item.AccountCode : null, item.AccountName]
    .filter(Boolean)
    .join(". ");

export function createAccountMaps(linesInfo, ...groupKeys) {
  const build = (items, keys) => {
    if (keys.length === 0) {
      return new Map(
        Object.entries(_.groupBy(items, getAccountKey)).map(
          ([account, lines]) => [
            account,
            {
              amount: lines.find((i) => i.Isstatoramount === 1),
              stat: lines.find((i) => i.Isstatoramount === 0),
            },
          ],
        ),
      );
    }

    const [key, ...rest] = keys;

    return new Map(
      Object.entries(_.groupBy(items, key)).map(([value, grouped]) => {
        const NValue = Number(value);
        const mapKey = Number.isNaN(NValue) ? value : NValue;

        return [mapKey, build(grouped, rest)];
      }),
    );
  };

  const result = build(linesInfo, groupKeys);

  window.accountMaps = result;

  return result;
}

export function getAccountTotals(linesInfo, amountKeys, statKeys) {
  const getTotals = (items, keys, type) =>
    Object.fromEntries(
      keys.map((key) => [
        key,
        items
          .filter((item) => item.Isstatoramount === type)
          .reduce((total, item) => total + (Number(item[key]) || 0), 0),
      ]),
    );

  const buildTotal = (items) => ({
    stat: getTotals(items, statKeys, 0),
    amount: getTotals(items, amountKeys, 1),
  });

  return new Map(
    Object.entries(_.groupBy(linesInfo, getAccountKey)).map(
      ([account, lines]) => [account, buildTotal(lines)],
    ),
  );
}

export function getExcelColumnName(index) {
  index++;
  let column = "";

  while (index > 0) {
    const remainder = (index - 1) % 26;
    column = String.fromCharCode(65 + remainder) + column;
    index = Math.floor((index - 1) / 26);
  }

  return column;
}

export function parseField(str) {
  str = str.replace("Total-", "");
  const period = periods.find((p) => str.startsWith(p));
  const base = bases.find((b) => str.includes(b)) || "";
  const comparison = comparisons.find((b) => str.includes(b)) || "";

  return { period, base, comparison };
}

export function isOrderFound(order, formula) {
  const regex = new RegExp(`(?<!\\d)${order}(?!\\d)`);
  return regex.test(formula);
}

window.getExcelColumnName = getExcelColumnName;
window.parseField = parseField;
